import { render, staticRenderFns } from "./DashboardFunctionalBraintrainingSection.vue?vue&type=template&id=3bed7fd2&scoped=true&"
import script from "./DashboardFunctionalBraintrainingSection.vue?vue&type=script&lang=js&"
export * from "./DashboardFunctionalBraintrainingSection.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFunctionalBraintrainingSection.vue?vue&type=style&index=0&id=3bed7fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed7fd2",
  null
  
)

/* custom blocks */
import block0 from "./DashboardFunctionalBraintrainingSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports